import SimilarTitle from "../models/SimilarTitle";

/**
 * @returns an array of SimilarTitleComponents
 */
export function projectCarouselResults(searchResultsTitles) {
    let retval = { titles: [] };
    if(searchResultsTitles && searchResultsTitles.Titles) {
        retval.summary = searchResultsTitles.Summary;
        retval.titles = searchResultsTitles.Titles.map((title) => {
            return new SimilarTitle(Object.assign({}, title, {
                bookjacket_url: title.bookjacket_url.url,
                author: ''
            }));
        });
    }
    return retval;
}



// WEBPACK FOOTER //
// ./src/data/CarouselItemSelector.js